import { HomeHeader } from "./components/home-header";
import { HomeSearch } from "./components/home-search";
import { useFeatureFlags } from "~/contexts/feature-flag-context";
import { BacklistLinks } from "./components/backlist-links";
import { BacklistMetadataGaps } from "./components/backlist-metadata-gaps";
import { EvaluationResults } from "./components/evaluation-results";
import { RecentProjects } from "./components/recent-projects/recent-projects";
import { UpcomingSeasonalEvents } from "./components/seasonal-events/upcoming-seasonal-events";
import { UploadManuscript } from "~/pages/upload-manuscript";

export const HomePage = () => {
  const { features } = useFeatureFlags();

  return (
    <div>
      <div className="-mx-16 -mt-8 mb-8 bg-secondary-25 flex flex-col justify-center items-center gap-4 py-14 px-10">
        <HomeHeader />
        <HomeSearch />
        <UpcomingSeasonalEvents />
      </div>

      <div className="w-full bg-white space-y-10">
        {features.metadataOptimisationCta ? (
          <BacklistMetadataGaps />
        ) : (
          <BacklistLinks />
        )}

        <RecentProjects />
        <UploadManuscript />
        <EvaluationResults />
      </div>
    </div>
  );
};
